import React from "react";
import { useNavigate } from "react-router-dom";
//import Login from "../auth/Login";
import LogoComponent from "./LogoComponent";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer
      className="bg-black text-white position-relative text-center py-3"
      style={{ zIndex: "1050", bottom: 0 }}
    >
      <LogoComponent />
      <p className="m-0" id="main-font">
        &copy; {new Date().getFullYear()} Proslay. All Rights Reserved.
      </p>
      <a
        style={{ cursor: "pointer" }}
        // className="display-6"
        id="main-font"
        onClick={() => navigate("/terms-conditions")}
      >
        Terms & Conditions
      </a>
    </footer>
  );
};

export default Footer;
